<template>
  <div class="ticker-wrapper">
    <div class="ticker">
      <span v-for="(info, index) in events" :key="index" class="ticker-item">
        {{ info.falecido }} - {{ formatarData(info.velorio) }} {{ formatarHora(info.velorio) }} -  {{ info.capela }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    events: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatarData(horario) {
      const [data] = horario.replace("-", "/").replace("-", "/").split(' ');
      return data;
    },
    formatarHora(valor) {
      const [, hora] = valor.split(' ');
      return hora;
    },
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.ticker-wrapper {
  width: 100%;
  overflow: hidden;
  background-color: #343F53;
  color: #fff;
  padding: 0.5rem 0;
  height: 8vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ticker {
  display: flex;
  white-space: nowrap;
  animation: move-ticker 100s linear infinite;
}

.ticker-item {
  font-family: "Poppins", sans-serif;
  margin-right: 4rem;
  font-size: 24px;
}

@keyframes move-ticker {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}
</style>
